"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const constants_1 = require("../../constants");
exports.ContactSchema = joi_1.default.object({
    createdAt: joi_1.default.date().required(),
    updatedAt: joi_1.default.date().required(),
    canBook: joi_1.default.boolean().required(),
    // While contacts without emails don't mean much to platform,
    // it is possible to create them in SF and assign email later
    email: joi_1.default.string()
        .email({ tlds: { allow: !constants_1.isBrowser } })
        .allow(null),
    salesforceId: joi_1.default.string().required(),
    organizationUuid: joi_1.default.string().uuid().required(),
    roles: joi_1.default.array().items(joi_1.default.string())
}).meta({ className: 'Contact' });
//# sourceMappingURL=ContactSchema.js.map